import { useEffect } from 'react';
import FruitHeightsHero from './components/FruitHeightsHero';
import FruitHeightsTrust from './components/FruitHeightsTrust';
import FruitHeightsServices from './components/FruitHeightsServices';
import FruitHeightsNeighborhoods from './components/FruitHeightsNeighborhoods';
import FruitHeightsTestimonial from './components/FruitHeightsTestimonial';
import FruitHeightsContact from './components/FruitHeightsContact';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function FruitHeightsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Fruit Heights Water Damage Restoration | Emergency Cleanup Services';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '24/7 emergency water damage restoration in Fruit Heights, UT. Serving Nicholls Park, Mountain Road, and all hillside neighborhoods. IICRC certified. Call (385) 340-6632 for immediate response.');
    setMeta('keywords', 'Fruit Heights water damage, Fruit Heights flood cleanup, Fruit Heights mold remediation, Fruit Heights fire damage, Fruit Heights storm damage, Fruit Heights restoration');
    setMeta('geo.position', '41.0302;-111.9016');
    setMeta('geo.placename', 'Fruit Heights, Utah');
    setMeta('geo.region', 'US-UT');
    setMeta('og:title', 'Fruit Heights Water Damage Restoration | Emergency Cleanup Services', true);
    setMeta('og:description', '24/7 emergency water damage restoration in Fruit Heights, UT. Serving Nicholls Park, Mountain Road, and all hillside neighborhoods. IICRC certified. Call (385) 340-6632 for immediate response.', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://daviscountydisastercleanup.com/fruit-heights', true);

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://daviscountydisastercleanup.com/fruit-heights');

    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What areas of Fruit Heights do you serve?',
          acceptedAnswer: { '@type': 'Answer', text: 'We serve all Fruit Heights neighborhoods including Nicholls Park Area, Mountain Road, East Fruit Heights, West Fruit Heights, Fruit Heights Estates, and Oak Hills.' },
        },
        {
          '@type': 'Question',
          name: 'How quickly can you respond to emergencies in Fruit Heights?',
          acceptedAnswer: { '@type': 'Answer', text: 'We provide 24/7 emergency response to Fruit Heights properties with arrival times of 45 minutes or less.' },
        },
        {
          '@type': 'Question',
          name: 'What restoration services do you offer in Fruit Heights?',
          acceptedAnswer: { '@type': 'Answer', text: 'We offer comprehensive restoration services including water damage restoration, emergency flood cleanup, mold remediation, fire damage repair, storm damage restoration, and odor removal.' },
        },
      ],
    };

    let schemaScript = document.querySelector('script[data-page="fruit-heights-faq"]') as HTMLScriptElement | null;
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.setAttribute('type', 'application/ld+json');
      schemaScript.setAttribute('data-page', 'fruit-heights-faq');
      document.head.appendChild(schemaScript);
    }
    schemaScript.textContent = JSON.stringify(schemaData);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FruitHeightsHero />
      <FruitHeightsTrust />
      <FruitHeightsServices />
      <FruitHeightsNeighborhoods />
      <FruitHeightsTestimonial />
      <FruitHeightsContact />
      <Footer />
    </div>
  );
}
